/**
 * Visible "KI" marker for tasks touched by the KI-Automation (git↔project
 * reconcile): rendered when a task was AI-created and/or AI-closed. Hidden
 * (renders null) when the task has no AI origin. The tooltip says which.
 */
import { Sparkles } from "lucide-preact";

interface Props {
  origin?: { created: boolean; closed: boolean } | null;
  /** Icon size in px (default 11). */
  size?: number;
}

export function AiOriginBadge({ origin, size = 11 }: Props): preact.JSX.Element | null {
  if (!origin || (!origin.created && !origin.closed)) return null;

  const parts: string[] = [];
  if (origin.created) parts.push("von KI erstellt");
  if (origin.closed) parts.push("von KI geschlossen");
  const label = parts.join(" · ");

  return (
    <span
      class="inline-flex items-center gap-0.5 rounded-sm bg-[color:var(--color-primary-container)] px-1 py-0.5 text-label font-medium text-[color:var(--color-on-primary-container)] shrink-0 leading-none"
      title={label}
      aria-label={label}
    >
      <Sparkles size={size} aria-hidden="true" />
      KI
    </span>
  );
}
